module.exports = __webpack_public_path__ + "img/team.88933794.svg";